import { ref } from 'vue'
import { backButtonCallback } from '@/router'

const showMemoryChallengeModal = ref(false)
const isReturningFromGame = ref(false)

export const useMemoryChallengeModal = () => {
  function openMemoryChallengeModal (fromGameReturn: boolean = false) {
    backButtonCallback.value = closeMemoryChallengeModal
    isReturningFromGame.value = fromGameReturn
    showMemoryChallengeModal.value = true
  }

  const closeMemoryChallengeModal = () => {
    backButtonCallback.value = null
    showMemoryChallengeModal.value = false
    setTimeout(() => {
      isReturningFromGame.value = false
    }, 300)
  }

  return {
    showMemoryChallengeModal,
    isReturningFromGame,
    openMemoryChallengeModal,
    closeMemoryChallengeModal,
  }
}